"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
function Filters({ fields, filters, actions, matchMode, children }) {
    const contextValue = {
        fields,
        filters,
        actions,
        matchMode
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.FiltersContext.Provider, {
        value: contextValue,
        children: children
    });
}
export { Filters };
